const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

(function () {
  if (window.__cvfInit) return;
  window.__cvfInit = true;

  var LS_KEY = 'partbot_selected_vehicle';
  var EVENTS = ['vehicle-garage-change', 'vehicle-search-change', 'plate-search-change', 'partbot-clear-vehicle'];

  var CAR_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"><path d="M24,16c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S28.4,16,24,16z M27,25h-2v2c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2h-2c-0.6,0-1-0.4-1-1s0.4-1,1-1h2v-2c0-0.6,0.4-1,1-1s1,0.4,1,1v2h2c0.6,0,1,0.4,1,1S27.6,25,27,25z"/><path d="M8.4,22l1.2-2.3c0.5-1,1.5-1.7,2.7-1.7h3.5c0.1,0,0.2,0,0.2,0c1.8-2.4,4.7-4,8-4c1.2,0,2.3,0.2,3.4,0.6C27,14,26.5,13.4,26,13h1c0.6,0,1-0.4,1-1s-0.4-1-1-1h-2.8L23,8c-0.8-1.8-2.6-3-4.6-3H9.6C7.6,5,5.8,6.2,5,8l-1.3,3H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c-1.2,0.9-2,2.4-2,4v4c0,0.9,0.4,1.7,1,2.2V25c0,1.7,1.3,3,3,3h2c1.7,0,3-1.3,3-3v-1h5c0-0.7,0.1-1.4,0.2-2H8.4z M7,19H4c-0.6,0-1-0.4-1-1s0.4-1,1-1h3c0.6,0,1,0.4,1,1S7.6,19,7,19z M5.5,12l1.4-3.2C7.4,7.7,8.4,7,9.6,7h8.7c1.2,0,2.3,0.7,2.8,1.8l1.4,3.2H5.5z"/></svg>';
  var CHECK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"><path fill-rule="evenodd" d="M24,16c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S28.4,16,24,16z M27.1,22.3l-3.5,4.1c-0.2,0.2-0.4,0.3-0.7,0.3c-0.3,0-0.5-0.1-0.7-0.3l-1.8-2.1c-0.4-0.4-0.3-1,0.1-1.4c0.4-0.4,1-0.3,1.4,0.1l1.1,1.3l2.8-3.3c0.4-0.4,1-0.5,1.4-0.1C27.5,21.3,27.5,21.9,27.1,22.3z"/><path d="M8.4,22l1.2-2.3c0.5-1,1.5-1.7,2.7-1.7h3.5c0.1,0,0.2,0,0.2,0c1.8-2.4,4.7-4,8-4c1.2,0,2.3,0.2,3.4,0.6C27,14,26.5,13.4,26,13h1c0.6,0,1-0.4,1-1s-0.4-1-1-1h-2.8L23,8c-0.8-1.8-2.6-3-4.6-3H9.6C7.6,5,5.8,6.2,5,8l-1.3,3H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c-1.2,0.9-2,2.4-2,4v4c0,0.9,0.4,1.7,1,2.2V25c0,1.7,1.3,3,3,3h2c1.7,0,3-1.3,3-3v-1h5c0-0.7,0.1-1.4,0.2-2H8.4z M7,19H4c-0.6,0-1-0.4-1-1s0.4-1,1-1h3c0.6,0,1,0.4,1,1S7.6,19,7,19z M5.5,12l1.4-3.2C7.4,7.7,8.4,7,9.6,7h8.7c1.2,0,2.3,0.7,2.8,1.8l1.4,3.2H5.5z"/></svg>';

  var CSS = [
    '.cvf-cardfit{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;margin:0 0 6px;padding:8px;border:0;border-radius:8px;font:inherit;font-size:14px;line-height:1.2;color:#1f2937;cursor:pointer;text-align:center}',
    '.cvf-cardfit__badge{display:inline-flex;align-items:center;justify-content:center;flex:none;width:14px;height:14px;border-radius:50%;color:#fff}',
    '.cvf-cardfit__badge svg{width:10px;height:10px}',
    '.cvf-cardfit--initial,.cvf-cardfit--check{background:#fff1e0}',
    '.cvf-cardfit--initial .cvf-cardfit__badge,.cvf-cardfit--check .cvf-cardfit__badge{background:#f59e0b}',
    '.cvf-cardfit--fits{background:#e3f5e9}',
    '.cvf-cardfit--fits .cvf-cardfit__badge{background:#22c55e}',
    '.cvf-cardfit--nofit{background:#ffe4e6}',
    '.cvf-cardfit--nofit .cvf-cardfit__badge{background:#ef4444}',
    'cart-drawer.is-empty .cart-vehicle-fitment{display:none}',
    '.cart-drawer .drawer__header{padding:1.2rem 0 0}',
    '.cart-drawer .drawer__heading{margin-bottom:1.2rem}',
    /* The empty cart's close button (.cde__close) gets the same round button as the full cart's. */
    '.cart-drawer .drawer__header .drawer__close,.cart-drawer .cde__close{top:9px;right:0;min-width:3.6rem;min-height:3.6rem;width:3.6rem;height:3.6rem;display:inline-flex;align-items:center;justify-content:center;border-radius:50%;background:rgb(var(--color-background));border:.1rem solid rgba(var(--color-foreground),.10);box-shadow:0 .2rem .7rem rgba(var(--color-foreground),.20);transition:background .1s ease,box-shadow .1s ease}',
    /* the empty cart has no header padding to sit inside, so inset it to match */
    '.cart-drawer .cde__close{right:1.5rem}',
    '.cart-drawer .drawer__header .drawer__close:hover,.cart-drawer .cde__close:hover{background:rgba(var(--color-foreground),.05);box-shadow:0 .3rem .9rem rgba(var(--color-foreground),.28)}',
    '.cart-drawer .drawer__header .drawer__close .svg-wrapper,.cart-drawer .cde__close .svg-wrapper{height:1.5rem;width:1.5rem;display:inline-flex;align-items:center;justify-content:center}',
    '.cart-drawer .recommendations-navigation__button{display:inline-flex;align-items:center;justify-content:center;width:3rem;height:3rem;padding:0;border-radius:50%;background:rgb(var(--color-background));border:.1rem solid rgba(var(--color-foreground),.10);box-shadow:0 .2rem .6rem rgba(var(--color-foreground),.18);transition:background .1s ease,box-shadow .1s ease}',
    '.cart-drawer .recommendations-navigation__button:hover{background:#ededed;box-shadow:0 .3rem .8rem rgba(var(--color-foreground),.26)}',
    '.cart-drawer .recommendations-navigation__button .svg-wrapper{display:inline-flex;align-items:center;justify-content:center;width:1.3rem;height:1.3rem}',
    '.cart-drawer .recommendations-navigation__button .svg-wrapper svg{width:100%;height:100%}',
    '.cvf-fit{display:inline-flex;align-items:center;gap:.4rem;margin-top:.6rem;padding:.25rem .7rem .25rem .35rem;font-size:1.1rem;font-weight:600;line-height:1.4;border-radius:8px;color:#1f2937}',
    '.cvf-fit__badge{display:inline-flex;align-items:center;justify-content:center;flex:0 0 auto;width:1.6rem;height:1.6rem;border-radius:9999px;color:#fff}',
    '.cvf-fit__badge svg{display:block;width:.9rem;height:.9rem}',
    '.cvf-fit--fits{background:#e3f5e9}',
    '.cvf-fit--fits .cvf-fit__badge{background:#22c55e}',
    '.cvf-fit--check{background:#fff1e0}',
    '.cvf-fit--check .cvf-fit__badge{background:#f59e0b}',
    '.cvf-fit--nofit{background:#ffe4e6}',
    '.cvf-fit--nofit .cvf-fit__badge{background:#ef4444}',
    '#menu-drawer .menu-drawer__menu > li.menu-drawer__vehicle{margin:0 0 10px}',
    '.cvf-menu{margin:0}',
    '.cvf-menu .cvf{padding:12px 14px;border-radius:10px;box-shadow:0 2px 10px rgba(16,24,40,.08);font-size:1.4rem}',
    '.cvf-menu .cvf--empty strong{font-size:1.6rem;font-weight:700}',
    '.cvf-tip{position:fixed;z-index:999;width:30rem;max-width:calc(100vw - 2.4rem);box-sizing:border-box;padding:1rem 1.2rem;color:#111;background:#fff;border:1px solid #e5e7eb;border-radius:1.2rem;box-shadow:0 .8rem 2.4rem rgba(0,0,0,.22);opacity:0;transform:translateY(.6rem);transition:opacity .25s ease,transform .25s ease}',
    '.cvf-tip--in{opacity:1;transform:none}',
    '.cvf-tip:before{content:"";position:absolute;top:-.7rem;left:var(--cvf-ax,2rem);width:1.4rem;height:1.4rem;background:#fff;border-radius:.2rem;transform:rotate(45deg)}',
    '.cvf-tip__title{font-weight:700;color:#111}',
    '.cvf-tip__text{margin:0;font-size:1.35rem;line-height:1.35;color:#374151}',
    '.cvf-tip__row{display:flex;align-items:center;gap:.6rem;margin-top:.8rem}',
    '.cvf-tip__add{padding:.9rem 1.2rem;font:inherit;font-size:1.35rem;font-weight:600;color:#fff;background:#017aff;border:0;border-radius:1.2rem;cursor:pointer}',
    '.cvf-tip__add:hover{background:#0068d9}',
    '.cvf-tip__skip{padding:.9rem .6rem;font:inherit;font-size:1.3rem;font-weight:500;color:#6b7280;background:none;border:0;cursor:pointer}',
    '.cvf-menu .cvf__icon{width:2.2rem;height:2.2rem}',
    /* + centred on the menu rows' arrows below it */
    '.cvf-menu .cvf__plus{margin-right:1.35rem}',
    '.cvf-menu .cvf__title{font-size:1.5rem}',
    '.cvf-menu .cvf__change{font-size:1.3rem;padding:.6rem .2rem}',
    /* Recommendation card layout (swipe row on every width) now lives in
       component-cart-drawer.css */
  ].join('');

  function injectStyles() {
    if (document.getElementById('cvf-styles')) return;
    var s = document.createElement('style');
    s.id = 'cvf-styles';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  function titleCase(str) {
    if (!str) return '';
    str = String(str).toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    return str.replace(/\bLandcruiser\b/g, 'LandCruiser');
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function readSelected() {
    try { return JSON.parse(localStorage.getItem(LS_KEY)) || null; } catch (e) { return null; }
  }

  function readVehicle() {
    var s = readSelected();
    var v = s && s.vehicle;
    if (!v || (!v.make && !v.model)) return null;
    return v;
  }

  function openGarage() {
    var triggers = document.querySelectorAll('[data-garage-trigger]');
    for (var i = 0; i < triggers.length; i++) {
      if (!triggers[i].closest('cart-drawer')) { triggers[i].click(); return; }
    }
    if (triggers[0]) triggers[0].click();
  }

  var FIT_SVG_OPEN = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" fill="currentColor">';
  var FIT = {
    fits: { label: 'Fitment Match', icon: FIT_SVG_OPEN + '<path d="M232.49,80.49l-128,128a12,12,0,0,1-17,0l-56-56a12,12,0,1,1,17-17L96,183,215.51,63.51a12,12,0,0,1,17,17Z"/></svg>' },
    check: { label: 'Might Fit', icon: FIT_SVG_OPEN + '<path d="M196,96c0,29.47-24.21,54.05-56,59.06V156a12,12,0,0,1-24,0V144a12,12,0,0,1,12-12c24.26,0,44-16.15,44-36s-19.74-36-44-36S84,76.15,84,96a12,12,0,0,1-24,0c0-33.08,30.5-60,68-60S196,62.92,196,96Zm-68,92a20,20,0,1,0,20,20A20,20,0,0,0,128,188Z"/></svg>' },
    nofit: { label: 'Not Compatible', icon: FIT_SVG_OPEN + '<path d="M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z"/></svg>' }
  };
  // Fitment per handle, kept for the browser session so each page view doesn't
  // repeat the Storefront lookup for the same cart and rec handles.
  var FIT_CACHE_KEY = 'cvf_fit_cache_v1';
  var fitCache = {};
  try { fitCache = JSON.parse(sessionStorage.getItem(FIT_CACHE_KEY)) || {}; } catch (e) {}
  var fitTimer = null;

  function uc(x) { return String(x == null ? '' : x).toUpperCase(); }

  function storefront() {
    var a = document.querySelector('[data-partbot-order-attribution]');
    if (!a) return null;
    var token = a.getAttribute('data-storefront-access-token');
    if (!token) return null;
    return { token: token, ver: a.getAttribute('data-storefront-api-version') || '2024-07' };
  }

  function fetchFitData(handles) {
    var sf = storefront();
    var need = [];
    for (var i = 0; i < handles.length; i++) {
      if (handles[i] && !(handles[i] in fitCache)) need.push(handles[i]);
    }
    if (!sf || !need.length) return Promise.resolve();
    var query = '{' + need.map(function (h, i) {
      return 'p' + i + ': product(handle: ' + JSON.stringify(h) + '){ yt: metafield(namespace: "app--1585807--partbot", key: "vehicle_year_tokens"){ value } sr: metafield(namespace: "app--1585807--partbot", key: "vehicle_series"){ value } }';
    }).join(' ') + '}';
    return fetch('/api/' + sf.ver + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': sf.token },
      body: JSON.stringify({ query: query })
    }).then(function (r) { return r.json(); }).then(function (j) {
      need.forEach(function (h, i) {
        var node = (j && j.data && j.data['p' + i]) || {};
        var tokens = [];
        if (node.yt && node.yt.value) { try { tokens = JSON.parse(node.yt.value).map(uc); } catch (e) {} }
        var series = [];
        if (node.sr && node.sr.value) {
          try {
            JSON.parse(node.sr.value).forEach(function (entry) {
              String(entry).split(',').forEach(function (s) { s = s.trim().toUpperCase(); if (s) series.push(s); });
            });
          } catch (e) {}
        }
        fitCache[h] = { tokens: tokens, series: series };
      });
      try { sessionStorage.setItem(FIT_CACHE_KEY, JSON.stringify(fitCache)); } catch (e) {}
    }).catch(function () { need.forEach(function (h) { if (!(h in fitCache)) fitCache[h] = { tokens: [], series: [] }; }); });
  }

  // The year + series rule lives once, in snippets/pb-grid-fit-sort (window.pbFit).
  function fitState(vehicle, data) {
    if (!vehicle || !data || !window.pbFit) return null;
    return window.pbFit.state(vehicle, data.tokens, data.series);
  }

  function cartRows() {
    var rows = document.querySelectorAll('cart-drawer .cart-item, #CartDrawer .cart-item');
    var out = [];
    for (var i = 0; i < rows.length; i++) {
      var link = rows[i].querySelector('a.cart-item__name, a[href*="/products/"]');
      if (!link) continue;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
      if (!m) continue;
      // Lines carry their own fitment (snippets/pb-fit-data in cart-drawer.liquid),
      // so their badges need no lookup. Products without PartBot data get none
      // printed and show as "Might Fit", as before.
      var data = null;
      if (rows[i].hasAttribute('data-pb-row') && window.pbFit) {
        data = window.pbFit.fromEl(rows[i]) || { tokens: [], series: [] };
      }
      out.push({ row: rows[i], handle: m[1], data: data });
    }
    return out;
  }

  function paintBadges() {
    var vehicle = readVehicle();
    var rows = cartRows();
    if (!vehicle) {
      var old = document.querySelectorAll('.cvf-fit');
      for (var k = 0; k < old.length; k++) old[k].remove();
      return;
    }
    rows.forEach(function (x) {
      var state = fitState(vehicle, x.data || fitCache[x.handle]);
      var existing = x.row.querySelector('.cvf-fit');
      if (!state) { if (existing) existing.remove(); return; }
      var cls = 'cvf-fit cvf-fit--' + state;
      if (existing && existing.getAttribute('data-state') === state) return;
      if (existing) existing.remove();
      var details = x.row.querySelector('.cart-item__details');
      if (!details) return;
      var b = document.createElement('span');
      b.className = cls;
      b.setAttribute('data-state', state);
      b.innerHTML = '<span class="cvf-fit__badge" aria-hidden="true">' + FIT[state].icon + '</span>' + FIT[state].label;
      // First tag in the options row (component-cart-drawer.css sizes it like
      // the option tags). Lines without options get it on its own after the title.
      var tags = details.querySelector('.cart-item__tags');
      var title = details.querySelector('.cart-item__name');
      if (tags) tags.insertBefore(b, tags.firstChild);
      else if (title) title.insertAdjacentElement('afterend', b);
      else details.appendChild(b);
    });
  }


  function recCards() {
    var cards = document.querySelectorAll('cart-drawer .recommendations-card, #CartDrawer .recommendations-card');
    var out = [];
    for (var i = 0; i < cards.length; i++) {
      var link = cards[i].querySelector('a.recommendations-card__media, a.recommendations-card__title');
      if (!link) continue;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
      if (!m) continue;
      out.push({ card: cards[i], handle: m[1] });
    }
    return out;
  }

  function paintRecBadges() {
    var vehicle = readVehicle();
    if (!vehicle) {
      var old = document.querySelectorAll('.recommendations-card .cvf-fit');
      for (var k = 0; k < old.length; k++) old[k].remove();
      return;
    }
    recCards().forEach(function (x) {
      var state = fitState(vehicle, fitCache[x.handle]);
      var existing = x.card.querySelector('.cvf-fit');
      if (!state) { if (existing) existing.remove(); return; }
      if (existing && existing.getAttribute('data-state') === state) return;
      if (existing) existing.remove();
      var details = x.card.querySelector('.recommendations-card__details');
      if (!details) return;
      var b = document.createElement('span');
      b.className = 'cvf-fit cvf-fit--' + state;
      b.setAttribute('data-state', state);
      b.innerHTML = '<span class="cvf-fit__badge" aria-hidden="true">' + FIT[state].icon + '</span>' + FIT[state].label;
      // On the price row, after the price (component-cart-drawer.css lays it out).
      var inner = details.querySelector('.recommendations-card__details-inner');
      if (inner) inner.appendChild(b); else details.appendChild(b);
    });
  }

  /*
    The carousel heading promises "Also fits your <series>", so anything the
    shopper's vehicle cannot take must not appear under it. Shopify's related
    recommendations are unfiltered, so drop the non-fitting slides here and cap
    what is left - eight cards is a lot of drawer, and on desktop they stack.
  */
  var REC_LIMIT = 4;

  function curateRecs() {
    var vehicle = readVehicle();
    var shown = 0;
    recCards().forEach(function (x) {
      var slide = x.card.closest('.cart-drawer__slide') || x.card;
      var state = vehicle ? fitState(vehicle, fitCache[x.handle]) : null;
      var hide = state === 'nofit' || shown >= REC_LIMIT;
      if (!hide) shown++;
      slide.classList.toggle('cvf-rec-hidden', hide);
    });

    var blocks = document.querySelectorAll('cart-drawer .cart-drawer__recommendations, #CartDrawer .cart-drawer__recommendations');
    for (var i = 0; i < blocks.length; i++) blocks[i].classList.toggle('cvf-rec-empty', shown === 0);

    // Let the native slider recount what is left (hidden slides drop out).
    var sl = document.querySelectorAll('cart-drawer slider-component.cart-drawer__slider');
    for (var k = 0; k < sl.length; k++) { if (typeof sl[k].resetPages === 'function') sl[k].resetPages(); }
  }

  /*
    The theme renders the prev/next arrows into a slot in the heading row
    (.cart-drawer__recommendations-navigation). They used to be moved into the
    slider and absolutely positioned against its edges, which needed a 20px
    gutter either side - 40px off an already narrow card, more padding than
    anything else in the block. Keep them in the heading slot; the native
    slider-component finds them by name="previous"/"next" anywhere inside it.
  */
  function positionRecNav() {
    var scopes = document.querySelectorAll('cart-drawer .cart-drawer__recommendations, #CartDrawer .cart-drawer__recommendations');
    for (var i = 0; i < scopes.length; i++) {
      var scope = scopes[i];
      var slot = scope.querySelector('.cart-drawer__recommendations-navigation');
      if (slot) {
        ['prev', 'next'].forEach(function (dir) {
          var btn = scope.querySelector('.recommendations-navigation__button-' + dir);
          if (btn && btn.parentNode !== slot) slot.appendChild(btn);
        });
      }

    }
  }

  function recTitleLabelNode(t) {
    var kids = t.childNodes;
    for (var i = 0; i < kids.length; i++) {
      var n = kids[i];
      if (n.nodeType === 3) { if (n.nodeValue && n.nodeValue.trim()) return n; }
      else if (n.nodeType === 1) {
        if (n.querySelector && n.querySelector('.recommendations-navigation__button')) continue;
        if (n.className && /navigation/.test(n.className)) continue;
        if (n.textContent && n.textContent.trim()) return n;
      }
    }
    return null;
  }

  function setRecTitle() {
    var vehicle = readVehicle();
    var titles = document.querySelectorAll('cart-drawer .cart-drawer__recommendations-title, #CartDrawer .cart-drawer__recommendations-title');
    for (var i = 0; i < titles.length; i++) {
      var t = titles[i];
      var node = recTitleLabelNode(t);
      if (!node) continue;
      if (!t.hasAttribute('data-cvf-default')) {
        t.setAttribute('data-cvf-default', (node.nodeType === 3 ? node.nodeValue : node.textContent).trim());
      }
      var text;
      if (vehicle) {
        var s = titleCase(vehicle.series) || titleCase(vehicle.model) || 'vehicle';
        text = 'Also fits your ' + s;
      } else {
        text = t.getAttribute('data-cvf-default') || 'Most people add:';
      }
      if (node.nodeType === 3) { if (node.nodeValue.trim() !== text) node.nodeValue = text; }
      else if (node.textContent.trim() !== text) node.textContent = text;
    }
  }

  function predictiveRows() {
    var items = document.querySelectorAll('predictive-search [data-pb-fit-item]');
    var out = [];
    for (var i = 0; i < items.length; i++) {
      var slot = items[i].querySelector('.predictive-search__fit-slot');
      if (slot) out.push({ el: items[i], slot: slot });
    }
    return out;
  }

  function parsePbListAttr(el, attr, splitComma) {
    var raw = el.getAttribute(attr);
    if (!raw) return [];
    var out = [];
    try {
      JSON.parse(raw).forEach(function (entry) {
        if (splitComma) {
          String(entry).split(',').forEach(function (s) { s = s.trim().toUpperCase(); if (s) out.push(s); });
        } else {
          out.push(uc(entry));
        }
      });
    } catch (e) {}
    return out;
  }

  // Fitment pills in the predictive-search dropdown. The section embeds each product's
  // PartBot year tokens + series as data attributes, so no network call is needed.
  function paintPredictiveBadges() {
    var rows = predictiveRows();
    if (!rows.length) return;
    var vehicle = readVehicle();
    rows.forEach(function (x) {
      var existing = x.slot.querySelector('.cvf-fit');
      if (!vehicle) {
        if (existing) existing.remove();
        x.el.removeAttribute('data-cvf-state');
        return;
      }
      var data = {
        tokens: parsePbListAttr(x.el, 'data-pb-yt', false),
        series: parsePbListAttr(x.el, 'data-pb-series', true)
      };
      var state = fitState(vehicle, data);
      if (!state) {
        if (existing) existing.remove();
        x.el.removeAttribute('data-cvf-state');
        return;
      }
      x.el.setAttribute('data-cvf-state', state);
      if (existing && existing.getAttribute('data-state') === state) return;
      if (existing) existing.remove();
      var b = document.createElement('span');
      b.className = 'cvf-fit cvf-fit--' + state;
      b.setAttribute('data-state', state);
      b.innerHTML = '<span class="cvf-fit__badge" aria-hidden="true">' + FIT[state].icon + '</span>' + FIT[state].label;
      x.slot.appendChild(b);
    });
    sortPredictiveProducts();
  }

  // Fitment-first ordering for dropdown products, mirroring pb-fitment-sort on the grids:
  // Fitment Match to the top, Not Compatible to the bottom, original order otherwise.
  function sortPredictiveProducts() {
    var items = document.querySelectorAll('predictive-search [data-pb-fit-item]');
    var lists = [];
    for (var i = 0; i < items.length; i++) {
      var ul = items[i].parentNode;
      if (ul && lists.indexOf(ul) === -1) lists.push(ul);
    }
    lists.forEach(function (ul) {
      var rows = [];
      for (var j = 0; j < ul.children.length; j++) {
        var el = ul.children[j];
        if (el.hasAttribute && el.hasAttribute('data-pb-fit-item')) {
          if (!el.hasAttribute('data-cvf-idx')) el.setAttribute('data-cvf-idx', String(rows.length));
          rows.push(el);
        }
      }
      if (rows.length < 2) return;
      var rank = function (el) {
        var s = el.getAttribute('data-cvf-state');
        if (s === 'fits') return 0;
        if (s === 'nofit') return 2;
        return 1;
      };
      var decorated = rows.map(function (el) {
        return { el: el, r: rank(el), i: parseInt(el.getAttribute('data-cvf-idx'), 10) || 0 };
      });
      decorated.sort(function (a, b) { return (a.r - b.r) || (a.i - b.i); });
      var changed = false;
      for (var k = 0; k < rows.length; k++) {
        if (rows[k] !== decorated[k].el) { changed = true; break; }
      }
      if (!changed) return;
      var frag = document.createDocumentFragment();
      decorated.forEach(function (o) { frag.appendChild(o.el); });
      ul.appendChild(frag);
    });
  }

  function watchPredictive() {
    if (!window.MutationObserver) return;
    var hosts = document.querySelectorAll('predictive-search [data-predictive-search]');
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].__cvfWatched) continue;
      hosts[i].__cvfWatched = true;
      // Paint and sort straight from the observer callback (it runs before the
      // browser paints), so the dropdown never shows its unsorted order first.
      // Painting is idempotent, so the mutations it causes settle immediately.
      new MutationObserver(function () {
        paintPredictiveBadges();
      }).observe(hosts[i], { childList: true, subtree: true });
    }
  }

  /*
    Product page "Frequently ordered together" (related-products) cards. PartBot's own
    card-fitment script deliberately skips product pages, so the theme paints a badge in
    the same spot and colours it uses on collection cards: above the quick add button,
    "Check Fitment" with no vehicle, else the year + series match from fitState().
  */
  function relatedCards() {
    var cards = document.querySelectorAll('product-recommendations.related-products .card-wrapper');
    var out = [];
    for (var i = 0; i < cards.length; i++) {
      var link = cards[i].querySelector('a[href*="/products/"]');
      var slot = cards[i].querySelector('.quick-add');
      if (!link || !slot) continue;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
      if (m) out.push({ card: cards[i], slot: slot, handle: m[1] });
    }
    return out;
  }

  function paintRelatedBadges() {
    var vehicle = readVehicle();
    relatedCards().forEach(function (x) {
      var state;
      var li = x.card.closest('ul[data-pb-instant] > li');
      if (li && window.pbFitSort) {
        // Same page data and rule the instant sort used, so badge and order agree
        // and nothing waits for the Storefront lookup.
        var r = vehicle ? window.pbFitSort.rank(li) : -1;
        state = r === -1 ? null : r === 0 ? 'fits' : r === 2 ? 'nofit' : 'check';
      } else {
        state = vehicle ? fitState(vehicle, fitCache[x.handle]) : null;
      }
      if (!state) state = 'initial';
      var existing = x.card.querySelector('.cvf-cardfit');
      if (existing && existing.getAttribute('data-state') === state) return;
      if (existing) existing.remove();
      var info = state === 'initial' ? { label: 'Check Fitment', icon: FIT.check.icon } : FIT[state];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cvf-cardfit cvf-cardfit--' + state;
      b.setAttribute('data-state', state);
      b.innerHTML = '<span class="cvf-cardfit__badge" aria-hidden="true">' + info.icon + '</span>' + info.label;
      b.addEventListener('click', function (e) { e.preventDefault(); openGarage(); });
      // First child of .quick-add, the same spot PartBot uses on collection cards,
      // so it sits between the price and the Add to cart button.
      x.slot.insertBefore(b, x.slot.firstChild);
    });
  }

  /*
    Related-products carousel order and filtering.
    No vehicle: Shopify's recommendations in their own order; best-seller fallback
    cards stay hidden.
    Vehicle saved: recommendations that are a Fitment Match first, then best-seller
    fallbacks that are a Fitment Match, then recommendations that might fit. Not
    Compatible cards are hidden (Shopify's related picks are often look-alikes, e.g.
    seat covers for other series). Capped at RELATED_LIMIT visible cards.
  */
  var RELATED_LIMIT = 10;

  function sortRelated() {
    var lists = document.querySelectorAll('product-recommendations.related-products ul');
    var hasVehicle = !!readVehicle();
    var pageMatch = location.pathname.match(/\/products\/([^?#\/]+)/);
    var pageHandle = pageMatch ? pageMatch[1] : '';
    for (var i = 0; i < lists.length; i++) {
      var ul = lists[i];
      if (ul.hasAttribute('data-pb-instant')) continue; // ordered by snippets/pb-grid-fit-sort
      var items = [];
      for (var j = 0; j < ul.children.length; j++) {
        var li = ul.children[j];
        if (!li.hasAttribute('data-cvf-idx')) li.setAttribute('data-cvf-idx', String(j));
        items.push(li);
      }
      if (!items.length) continue;
      var seen = {};
      var plan = items.map(function (li) {
        var fallback = li.classList.contains('related-products__fallback');
        var link = li.querySelector('a[href*="/products/"]');
        var m = link && (link.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
        var handle = m ? m[1] : '';
        var b = li.querySelector('.cvf-cardfit');
        var st = b && b.getAttribute('data-state');
        var group;
        if (handle && handle === pageHandle) group = 9;
        else if (!hasVehicle) group = fallback ? 9 : 0;
        else if (st === 'nofit') group = 9;
        else if (st === 'fits') group = fallback ? 1 : 0;
        else group = fallback ? 9 : 2;
        if (group < 9 && handle) {
          if (seen[handle]) group = 9;
          seen[handle] = true;
        }
        return { li: li, g: group, i: parseInt(li.getAttribute('data-cvf-idx'), 10) || 0 };
      }).sort(function (a, b) { return (a.g - b.g) || (a.i - b.i); });
      var shown = 0;
      var changed = false;
      plan.forEach(function (o, k) {
        var show = o.g < 9 && shown < RELATED_LIMIT;
        if (show) shown++;
        var want = show ? '' : 'none';
        if (o.li.style.display !== want) { o.li.style.display = want; changed = true; }
        if (items[k] !== o.li) changed = true;
      });
      if (!changed) continue;
      var frag = document.createDocumentFragment();
      plan.forEach(function (o) { frag.appendChild(o.li); });
      ul.appendChild(frag);
      ul.scrollLeft = 0;
      var slider = ul.closest('slider-component');
      if (slider && typeof slider.resetPages === 'function') slider.resetPages();
    }
  }

  function watchRelated() {
    if (!window.MutationObserver) return;
    var hosts = document.querySelectorAll('product-recommendations.related-products');
    for (var i = 0; i < hosts.length; i++) {
      if (hosts[i].__cvfWatched) continue;
      hosts[i].__cvfWatched = true;
      new MutationObserver(function (muts) {
        for (var j = 0; j < muts.length; j++) {
          for (var k = 0; k < muts[j].addedNodes.length; k++) {
            var n = muts[j].addedNodes[k];
            if (n.nodeType === 1 && !(n.classList && n.classList.contains('cvf-cardfit'))) { scheduleFit(); return; }
          }
        }
      }).observe(hosts[i], { childList: true, subtree: true });
    }
  }

  // Homepage carousels sort themselves before paint (snippets/pb-grid-fit-sort,
  // ul[data-pb-instant]); this pass only covers the cart, recs and older lists.
  function applyBadges() {
    // Surfaces that carry their fitment in the page paint now, not after the lookup.
    paintPredictiveBadges();
    paintRelatedBadges();
    var paint = function () { paintBadges(); paintRecBadges(); curateRecs(); paintPredictiveBadges(); paintRelatedBadges(); sortRelated(); };
    // Every badge and sort needs a saved vehicle, so without one skip the lookup
    // and just clear anything left from a previous vehicle.
    if (!readVehicle()) { paint(); return; }
    var handles = cartRows().filter(function (x) { return !x.data; }).map(function (x) { return x.handle; })
      .concat(recCards().map(function (x) { return x.handle; }))
      .concat(relatedCards().filter(function (x) { return !x.card.closest('ul[data-pb-instant]'); }).map(function (x) { return x.handle; }));
    fetchFitData(handles).then(paint);
  }

  function scheduleFit() {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(applyBadges, 120);
  }

  function markup(ctx) {
    var sel = readSelected();
    var v = sel && sel.vehicle;
    if (v && (v.make || v.model)) {
      var title = [v.make, v.model, v.year].filter(Boolean).join(' ');
      var detail = (sel.description || '').trim();
      if (detail && detail.toUpperCase().indexOf(title.toUpperCase()) === 0) detail = detail.slice(title.length).trim();
      if (!detail && v.series) detail = v.series;
      return '<div class="cvf cvf--set">' +
        '<span class="cvf__icon" aria-hidden="true">' + CHECK_SVG + '</span>' +
        '<span class="cvf__text"><strong class="cvf__title">' + escapeHtml(title) + '</strong>' +
        (detail ? '<span class="cvf__detail">' + escapeHtml(detail) + '</span>' : '') +
        '</span>' +
        '<button type="button" class="cvf__change" data-cvf-open>Change</button>' +
        '</div>';
    }
    return '<button type="button" class="cvf cvf--empty" data-cvf-open>' +
      '<span class="cvf__icon" aria-hidden="true">' + CAR_SVG + '</span>' +
      (ctx === 'menu'
        ? '<span class="cvf__text"><strong>ADD MY VEHICLE</strong><span class="cvf__sub">See only the parts that fit your vehicle</span></span>'
        : '<span class="cvf__text"><strong>ADD MY VEHICLE</strong><span class="cvf__sub">Confirm these parts fit your vehicle</span></span>') +
      '<span class="cvf__plus" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></span>' +
      '</button>';
  }

  function renderInto(el) {
    var inMenu = el.classList.contains('cvf-menu');
    el.innerHTML = markup(inMenu ? 'menu' : null);
    var btns = el.querySelectorAll('[data-cvf-open]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function (e) {
        e.preventDefault();
        if (inMenu) closeMenuDrawer();
        openGarage();
      });
    }
  }

  window.cvfRender = renderInto; // instant search's copy of the banner

  // Mobile menu drawer: the garage picker opens behind the drawer, so close it first.
  // Dawn's closeMenuDrawer() is a silent no-op unless it gets an event AND the summary to
  // refocus; called bare it left body.overflow-hidden-* on and the page couldn't scroll.
  function closeMenuDrawer() {
    var drawer = document.querySelector('header-drawer');
    if (!drawer) return;
    var summary = drawer.querySelector('details > summary');
    try {
      if (typeof drawer.closeMenuDrawer === 'function' && summary) {
        drawer.closeMenuDrawer(new Event('click'), summary);
        summary.setAttribute('aria-expanded', 'false');
      }
    } catch (e) {}
    // Belt and braces: never leave the scroll lock behind.
    var bp = drawer.dataset && drawer.dataset.breakpoint;
    if (bp) document.body.classList.remove('overflow-hidden-' + bp);
    var header = document.querySelector('.section-header');
    if (header) header.classList.remove('menu-open');
  }

  function ensureMenuTile() {
    var els = document.querySelectorAll('.cvf-menu');
    for (var i = 0; i < els.length; i++) if (!els[i].firstChild) renderInto(els[i]);
  }
  // The phone menu's contents are built on first use (HeaderDrawer.renderContents).
  document.addEventListener('menu-drawer:rendered', ensureMenuTile);

  function ensure() {
    var headers = document.querySelectorAll('cart-drawer .drawer__header, #CartDrawer .drawer__header');
    for (var i = 0; i < headers.length; i++) {
      var header = headers[i];
      var parent = header.parentElement;
      if (!parent) continue;
      if (parent.querySelector(':scope > .cart-vehicle-fitment')) continue;
      var el = document.createElement('div');
      el.className = 'cart-vehicle-fitment';
      el.setAttribute('aria-live', 'polite');
      header.insertAdjacentElement('afterend', el);
      renderInto(el);
    }
  }

  function isCollectionPage() {
    var p = location.pathname;
    return /\/collections\/[^\/?#]+/.test(p) && p.indexOf('/products/') === -1;
  }

  function isSearchPage() {
    return location.pathname.indexOf('/search') === 0;
  }

  function ensureCollectionBanner() {
    if (!isCollectionPage() && !isSearchPage()) return;
    // Collection and search pages render the banner in the template
    // (snippets/vehicle-fitment-banner.liquid); this is only a fallback.
    if (document.querySelector('.cvf-collection')) return;
    var grid = document.querySelector('#ProductGridContainer');
    if (!grid) return;
    var el = document.createElement('div');
    el.className = 'cart-vehicle-fitment cvf-collection page-width';
    el.setAttribute('aria-live', 'polite');
    if (isSearchPage()) {
      // On search, sit right below the page title: before the sort row (or the filters + grid).
      var anchor = document.querySelector('.facets-vertical-sort') || document.querySelector('.facets-vertical') || grid;
      anchor.parentNode.insertBefore(el, anchor);
    } else {
      var mount = grid.closest('[class*="-padding"]') || grid.closest('.shopify-section') || grid.parentNode;
      if (!mount) return;
      mount.insertBefore(el, mount.firstChild);
    }
    renderInto(el);
  }

  // "Check fitment" tooltip on the header Add Vehicle button. Shown on the home page, and on
  // product pages that have PartBot fitment data, but never on the first page of a visit
  // there (ad landers need the product first). No dim layer: taps elsewhere still work and
  // also close it. It appears 2s after load only while the page is still at the top, closes
  // for good after a third of a screen of scrolling or once its button scrolls out of view,
  // and fades out after 8s. At most once per
  // session, 3 days apart, 3 times per browser, never once a vehicle is set or after "Add
  // vehicle" is tapped. Add ?cvf_tip=1 to any URL to force it. Each showing and how it ended
  // is sent to Clarity as cvf_tip_* events plus a cvf_tip tag.
  var TIP_KEY = 'cvf_tip_v1';
  var TIP_PV_KEY = 'cvf_tip_pv';
  var tipEl = null;
  var tipMenuObs = null;
  var tipTimer = null;
  var tipStartY = 0;
  var tipPageViews = 0;
  var TIP_GAP_MS = 3 * 24 * 60 * 60 * 1000;
  var TIP_DELAY_MS = 2000;
  var TIP_LIFE_MS = 8000;

  function tipState() {
    try { return JSON.parse(localStorage.getItem(TIP_KEY)) || { shown: 0, done: false }; } catch (e) { return { shown: 0, done: false }; }
  }
  function saveTipState(st) {
    try { localStorage.setItem(TIP_KEY, JSON.stringify(st)); } catch (e) {}
  }
  function tipForced() {
    return /[?&]cvf_tip=1/.test(location.search);
  }
  function tipTrack(name, tag) {
    // Same queue stub as the Clarity loader in theme.liquid, so events sent before the
    // tag has loaded are picked up when it does.
    try {
      window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
      window.clarity('event', name);
      if (tag) window.clarity('set', 'cvf_tip', tag);
    } catch (e) {}
  }
  function countPageView() {
    try {
      tipPageViews = (parseInt(sessionStorage.getItem(TIP_PV_KEY), 10) || 0) + 1;
      sessionStorage.setItem(TIP_PV_KEY, String(tipPageViews));
    } catch (e) {
      // No sessionStorage: treat a same-site referrer as "not the landing page".
      tipPageViews = document.referrer.indexOf(location.origin) === 0 ? 2 : 1;
    }
  }
  function tipPageType() {
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page;
    if (meta && meta.pageType) return meta.pageType;
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(location.pathname)) return 'home';
    if (/\/products\//.test(location.pathname)) return 'product';
    return '';
  }
  function productHasFitment() {
    var el = document.querySelector('partbot-vehicle-fitment');
    if (!el) return false;
    var ids = (el.getAttribute('data-vehicle-ids') || '').replace(/[,\s]/g, '');
    var tokens = (el.getAttribute('data-vehicle-year-tokens') || '').replace(/\s/g, '');
    return ids !== '' || (tokens !== '' && tokens !== '[]');
  }
  function tipPageOk() {
    var type = tipPageType();
    if (type === 'home') return true;
    if (type === 'product') return tipPageViews > 1 && productHasFitment();
    return false;
  }
  function tipAllowed() {
    if (tipForced()) return true;
    if (readVehicle()) return false;
    if (!tipPageOk()) return false;
    var st = tipState();
    if (st.done || st.shown >= 3) return false;
    if (st.last && Date.now() - st.last < TIP_GAP_MS) return false;
    try { if (sessionStorage.getItem(TIP_KEY)) return false; } catch (e) {}
    return true;
  }
  function tipAnchor() {
    var btns = document.querySelectorAll('.find-vehicle__button');
    for (var i = 0; i < btns.length; i++) {
      var r = btns[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return btns[i];
    }
    return null;
  }
  function onScreen(el) {
    var r = el.getBoundingClientRect();
    if (r.width < 2 || r.height < 2 || r.right <= 0 || r.bottom <= 0 || r.left >= window.innerWidth || r.top >= window.innerHeight) return false;
    var cs = getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity) > 0.05;
  }
  function tipBlocked() {
    // Something else already has the shopper's attention (drawers, search, pop-ups).
    // Closed dialogs keep aria-modal in the DOM, so only count ones actually on screen.
    if (document.querySelector('cart-drawer.active, header-drawer details[open], details-modal details[open]')) return true;
    var focused = document.activeElement;
    if (focused && /^(INPUT|TEXTAREA|SELECT)$/.test(focused.tagName)) return true;
    var dialogs = document.querySelectorAll('[aria-modal="true"], [role="dialog"]');
    for (var i = 0; i < dialogs.length; i++) {
      if (dialogs[i] !== tipEl && onScreen(dialogs[i])) return true;
    }
    return false;
  }
  function placeTip() {
    if (!tipEl) return;
    var a = tipAnchor();
    var r = a && a.getBoundingClientRect();
    // The mobile header scrolls away with the page; once the button it points at
    // starts to leave the screen, the tip goes too rather than floating on its own.
    if (!r || r.top < 0) { hideTip(false, 'scroll'); return; }
    var left = Math.max(12, Math.min(r.left - 2, window.innerWidth - tipEl.offsetWidth - 12));
    tipEl.style.top = (r.bottom + 12) + 'px';
    tipEl.style.left = left + 'px';
    tipEl.style.setProperty('--cvf-ax', (r.left + r.width / 2 - left - 7) + 'px');
  }
  function hideTip(done, reason) {
    if (!tipEl) return;
    if (done) { var st = tipState(); st.done = true; saveTipState(st); }
    if (reason) tipTrack('cvf_tip_' + reason, reason);
    var el = tipEl;
    tipEl = null;
    clearTimeout(tipTimer);
    el.classList.remove('cvf-tip--in');
    window.removeEventListener('scroll', tipScroll);
    window.removeEventListener('resize', placeTip);
    document.removeEventListener('keydown', tipKey);
    document.removeEventListener('click', tipClick, true);
    if (tipMenuObs) { tipMenuObs.disconnect(); tipMenuObs = null; }
    setTimeout(function () { el.remove(); }, 250);
  }
  function tipScroll() {
    if (Math.abs(window.scrollY - tipStartY) > window.innerHeight / 3) { hideTip(false, 'scroll'); return; }
    placeTip();
  }
  function tipKey(e) { if (e.key === 'Escape') hideTip(false, 'esc'); }
  function tipClick(e) {
    if (!tipEl || tipEl.contains(e.target)) return;
    if (e.target.closest && e.target.closest('[data-garage-trigger]')) { hideTip(true, 'header_add'); return; }
    // A tap anywhere else closes the tip but is never swallowed: whatever was tapped
    // (Add to Cart, the gallery, a swatch) still gets its click. Listening for click
    // rather than pointerdown means a finger that starts a scroll doesn't count.
    hideTip(false, 'tap');
  }
  function watchMenuOpen() {
    // Desktop mega-menu dropdowns open below the header, where the tip sits, so get out of
    // the way only when one actually opens (a mouse passing over the header is not enough).
    var hdr = document.querySelector('.header-wrapper');
    if (!hdr || !window.MutationObserver) return;
    tipMenuObs = new MutationObserver(function () {
      if (hdr.querySelector('details[open]')) hideTip(false, 'menu');
    });
    tipMenuObs.observe(hdr, { subtree: true, attributes: true, attributeFilter: ['open'] });
  }
  function showTip() {
    if (tipEl || !tipAllowed() || !tipAnchor()) return;
    // Only at the top of the page: once the shopper is reading, leave them to it.
    if (!tipForced() && window.scrollY > 40) return;
    if (tipBlocked()) { setTimeout(showTip, 3000); return; }
    if (!tipForced()) {
      var st = tipState(); st.shown += 1; st.last = Date.now(); saveTipState(st);
      try { sessionStorage.setItem(TIP_KEY, '1'); } catch (e) {}
    }
    var onProduct = tipPageType() === 'product';
    tipEl = document.createElement('div');
    tipEl.className = 'cvf-tip';
    tipEl.setAttribute('role', 'status');
    tipEl.innerHTML = '<p class="cvf-tip__text"><strong class="cvf-tip__title">Check fitment:</strong> ' +
      (onProduct ? 'confirm this part fits your vehicle' : 'see the parts that fit your vehicle') + '</p>' +
      '<div class="cvf-tip__row"><button type="button" class="cvf-tip__add">ADD MY VEHICLE</button>' +
      '<button type="button" class="cvf-tip__skip">Not now</button></div>';
    tipEl.querySelector('.cvf-tip__add').addEventListener('click', function () { hideTip(true, 'add'); openGarage(); });
    tipEl.querySelector('.cvf-tip__skip').addEventListener('click', function () { hideTip(false, 'not_now'); });
    document.body.appendChild(tipEl);
    placeTip();
    tipStartY = window.scrollY;
    window.addEventListener('scroll', tipScroll, { passive: true });
    window.addEventListener('resize', placeTip);
    document.addEventListener('keydown', tipKey);
    document.addEventListener('click', tipClick, true);
    watchMenuOpen();
    tipTimer = setTimeout(function () { hideTip(false, 'timeout'); }, TIP_LIFE_MS);
    tipTrack('cvf_tip_shown', 'shown');
    void tipEl.offsetWidth; // commit the start state so the fade-in transition runs
    tipEl.classList.add('cvf-tip--in');
  }
  // Instant search opens over the page and closes the tip through this.
  window.cvfHideTip = function (reason) { hideTip(false, reason || 'other'); };

  function scheduleTip() {
    countPageView();
    if (tipAllowed()) setTimeout(showTip, tipForced() ? 800 : TIP_DELAY_MS);
  }

  function refresh() {
    if (readVehicle()) hideTip(true);
    var els = document.querySelectorAll('.cart-vehicle-fitment');
    for (var i = 0; i < els.length; i++) renderInto(els[i]);
    setRecTitle();
    scheduleFit();
  }

  function start() {
    injectStyles();
    ensure();
    positionRecNav();
    setRecTitle();
    scheduleFit();
    ensureCollectionBanner();
    ensureMenuTile();
    watchPredictive();
    watchRelated();
    scheduleTip();

    var host = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
    if (host && window.MutationObserver) {
      // Line badges come from the lines' own data, so paint them before the
      // re-rendered drawer is drawn; the rest waits for the debounced pass.
      new MutationObserver(function () { ensure(); positionRecNav(); setRecTitle(); paintBadges(); scheduleFit(); }).observe(host, { childList: true, subtree: true });
    }

    for (var i = 0; i < EVENTS.length; i++) {
      window.addEventListener(EVENTS[i], refresh);
      document.addEventListener(EVENTS[i], refresh);
    }
    window.addEventListener('storage', function (e) { if (e.key === LS_KEY) refresh(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
